import { render, staticRenderFns } from "./PaypalEmbeddedFields.vue?vue&type=template&id=44848c79&"
import script from "./PaypalEmbeddedFields.vue?vue&type=script&lang=js&"
export * from "./PaypalEmbeddedFields.vue?vue&type=script&lang=js&"
import style0 from "./PaypalEmbeddedFields.vue?vue&type=style&index=0&id=44848c79&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports